export default __webpack_public_path__ + "static/media/G0890_Bimanual_compression.1702917960000.66142a40.jpg";